import React, { Component } from 'react';
import moment from 'moment-timezone';
import TextInput from '../subComponents/TextInput';
import CustomButton from '../subComponents/CustomButton';
import './MoveBooking.css';
import DropDown from '../subComponents/DropDown';
import { connect } from 'react-redux';
import * as API from '../../api';
import { receiveTimeslots, stepMoveBooking, stepLoading, selectDay, stepConfirmation, stepFailure, receiveCredentials } from '../../redux';

const mapStateToProps = (state) => ({
  booking: state.moveBooking,
  selectedDay: state.selectedDay,
  timeslots: state.timeslots.timeslots,
  bookingCode: state.credentials.bookingCode
});

const mapDispatchToProps = (dispatch) => ({
  receiveTimeslots: (data) => dispatch(receiveTimeslots(data)),
  stepMoveBooking: () => dispatch(stepMoveBooking()),
  stepLoading: () => dispatch(stepLoading()),
  stepConfirmation: () => dispatch(stepConfirmation()),
  stepFailure: () => dispatch(stepFailure()),
  selectDay: (day) => dispatch(selectDay(day)),
  receiveNewBooking: (newCode, errMsg) => dispatch(receiveCredentials({ newBookingCode: newCode, errMsg: errMsg }))
});

export default connect(mapStateToProps, mapDispatchToProps)(class MoveBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moveDisabled: true,
      selectedTimeslotMap: {},
      dropDownsDisabled: true,
      errorMessage: ''
    }
  }

  componentDidMount() {
    const { selectedDay, booking } = this.props;
    let dropDownsDisabled = true;
    let selectedTimeslotMap = {};

    if (selectedDay && selectedDay !== '') {
      dropDownsDisabled = false;
    }

    for (let timeslotId in booking.timeslots) {
      const ts = booking.timeslots[timeslotId];
      selectedTimeslotMap[ts.timeslot_id] = '';
    }

    this.setState({
      dropDownsDisabled,
      selectedTimeslotMap
    });
  }

  validate = () => {
    const { booking, selectedDay } = this.props;
    const { selectedTimeslotMap } = this.state;
    let valid = true;

    // same length
    if (Object.keys(selectedTimeslotMap).length === booking.timeslots.length && selectedDay && selectedDay !== '') {
      for (let i in selectedTimeslotMap) {
        if (!selectedTimeslotMap[i] || selectedTimeslotMap[i] === '') valid = false;
      }
    }
    else valid = false

    return valid;
  }

  onMoveClick = () => {
    const { stepLoading, bookingCode, stepConfirmation, stepFailure, receiveNewBooking } = this.props;
    const { selectedNewTimeslots } = this.state;

    if (this.validate()) {
      stepLoading();
      API.webMoveBooking(bookingCode, selectedNewTimeslots)
        .then(result => {
          console.log(result);
          console.log(result.response);
          receiveNewBooking(result.response.new_booking_code, result.response.result_message);
          stepConfirmation();
        })
        .catch(error => {
          console.error('Failed to move booking: ', error);
          stepFailure();
        });
    }
  }

  onDateChange = (event) => {
    const { booking, receiveTimeslots, selectDay } = this.props;
    let selectedDay = event.target.value;
    let dropDownsDisabled = false;
    let errorMessage = '';

    this.setState({ errorMessage });

    if (
      !selectedDay
      || selectedDay === ''
    ) dropDownsDisabled = true;

    if (moment(selectedDay).valueOf() <= moment().subtract(1, 'day').valueOf()) {
      selectedDay = '';
      errorMessage = 'Date is unavailable.';
      dropDownsDisabled = true;
    }
    else {
      API.getTimeslotsForDay(selectedDay, booking.location_id)
        .then(result => {
          receiveTimeslots(result);

          if (result.timeslots.filter(ts => ts.available_quantity !== 0).length === 0)
            errorMessage = 'Date has no bookings available.';
          this.setState({ errorMessage });
        })
        .catch(error => {
          console.error('Failed to get timeslots info: ', error);
        });
    }

    selectDay(selectedDay);
    if (errorMessage !== '') this.setState({ selectedTimeslotMap: {} });

    this.setState({
      dropDownsDisabled,
      errorMessage
    });
  }

  onNewTimeslotChange = (timeslotId) => event => {
    let moveDisabled = true;
    let newSelected = this.state.selectedTimeslotMap;
    newSelected[timeslotId] = event.target.value.toString();

    if (Object.keys(newSelected).length === this.props.booking.timeslots.length) {
      let isEmpty = false;
      for (let i in newSelected) {
        if (!newSelected[i] || newSelected[i] === '') isEmpty = true;
      }
      moveDisabled = isEmpty;
    }

    // check if enough spots available
    for (let tsToMoveId in newSelected) {
      const tsToPickId = newSelected[tsToMoveId];
      if (!tsToPickId || tsToPickId === '') continue;

      const tsToPickQuantity = this.props.timeslots.find(e => {
        return e.id === tsToPickId;
      }).available_quantity;
      const tsToMoveQuantity = this.getQuantity(this.props.booking.timeslots.find(e => {
        return e.timeslot_id === parseInt(tsToMoveId, 10);
      }).items);

      if (tsToPickQuantity < tsToMoveQuantity) {
        moveDisabled = true;
        break;
      }
    }

    this.setState({
      selectedNewTimeslots: newSelected,
      moveDisabled,
    });
  }

  formatDate = (date, timeZone) => {
    return moment(date).tz(timeZone).format('ddd MMM D, h:mma');
  }

  getQuantity = (arr) => {
    let len = arr.length;
    let total = 0;
    for (let i = 0; i < len; i++) {
      total += arr[i].quantity;
    }
    return total;
  }

  render() {
    const { selectedDay, booking, timeslots } = this.props;
    const { selectedTimeslotMap, dropDownsDisabled, moveDisabled } = this.state;
    return (
      <div className={'MoveBooking'}>
        <table style={{ borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td>
                <TextInput
                  label={'Select a Day'}
                  type={'date'}
                  value={selectedDay}
                  onChange={this.onDateChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </td>
              <td className={'MoveBooking-dayError'}>
                {this.state.errorMessage !== '' ? 'ERROR: ' + this.state.errorMessage : ''}
              </td>
            </tr>
            <tr>
              <td className={'MoveBooking-Header'}>
                Current Timeslots
              </td>
              <td className={'MoveBooking-Header'}>
                New Timeslots
              </td>
            </tr>
            <tr>
              <td className={'MoveBooking-Separator'}></td>
              <td className={'MoveBooking-Separator'}></td>
            </tr>
            {booking.timeslots && booking.timeslots.map((timeslot, index) => {
              return (
                <tr key={index}>
                  <td>
                    <div className={'MoveBooking-Current'}>
                      {timeslot.items[0].title}: {this.formatDate(timeslot.start_time_utc, booking.time_zone)} ({this.getQuantity(timeslot.items)})
                    </div>
                  </td>
                  <td>
                    <DropDown
                      label={(!selectedDay || selectedDay === '') ? 'Select a Day' : 'Select a Timeslot'}
                      onChange={this.onNewTimeslotChange(timeslot.timeslot_id)}
                      value={selectedTimeslotMap[timeslot.timeslot_id]}
                      disabled={dropDownsDisabled}
                      options={timeslots ? (timeslots.filter(ts => {
                        return (
                          ts.item_category_id === timeslot.items[0].item_category_id
                          && moment(ts.start_time).valueOf() > moment().valueOf()
                        );
                      }).map(ts => {
                        return {
                          title: this.formatDate(ts.start_time, booking.time_zone) + ' (' + ts.available_quantity + ')',
                          value: ts.id
                        }
                      })) : []}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className={'MoveBooking-Button'}>
          <CustomButton
            text={'MOVE'}
            icon={'send'}
            onClick={this.onMoveClick}
            disabled={moveDisabled}
          />
        </div>
      </div>
    );
  }
});
